import React from "react";
import { useTranslation } from "react-i18next";

import BaseBadge from "@/components_v2/Badge/BaseBadge";
import BaseSvgRenderer from "@/components_v2/Svg/BaseSvgRenderer";
import Clock from "@/assets/icons/clock.svg?react";
import Check from "@/assets/icons/check-circle.svg?react";
import Partial from "@/assets/icons/partial.svg?react";
import { SuggestionStatus } from "@/shared/utils/constants";
import { SuggestionStatusBadgeProps } from "@/features/survey/form/types";

const SuggestionStatusBadge = ({
  suggestionStatus,
  sourceSurvey,
  isDisabled,
  onClick,
}: SuggestionStatusBadgeProps) => {
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(e);
  };

  const badgeClassName = `question-badge-status ${isDisabled && "question-badge-suggestion-active"}`;

  switch (suggestionStatus) {
    case SuggestionStatus.AVAILABLE:
      return (
        <BaseBadge
          className={badgeClassName}
          backgroundColor="var(--primary-500-10)"
          borderColor="var(--primary-500)"
          fontColor="var(--primary-500)"
          leadingIcon={
            <BaseSvgRenderer component={Clock} stroke="var(--primary-500)" />
          }
          onClick={handleClick}
        >
          {t("survey.labels.badgeStateAvailable", {
            surveyTitle: sourceSurvey?.title,
          })}
        </BaseBadge>
      );

    case SuggestionStatus.PARTIALLY_APPLIED:
      return (
        <BaseBadge
          className={badgeClassName}
          backgroundColor="var(--orange-500-10)"
          borderColor="var(--orange-300)"
          fontColor="var(--orange-500)"
          leadingIcon={
            <BaseSvgRenderer
              component={Partial}
              stroke="var(--orange-500)"
              fill="var(--orange-500)"
            />
          }
          onClick={handleClick}
        >
          {t("survey.labels.badgeStatePartiallyApplied", {
            surveyTitle: sourceSurvey?.title,
          })}
        </BaseBadge>
      );

    case SuggestionStatus.APPLIED:
      return (
        <BaseBadge
          backgroundColor="var(--green-700-10)"
          borderColor="var(--green-700)"
          fontColor="var(--green-700)"
          leadingIcon={
            <BaseSvgRenderer component={Check} stroke="var(--green-700)" />
          }
        >
          {t("survey.labels.badgeStateApplied", {
            surveyTitle: sourceSurvey?.title,
          })}
        </BaseBadge>
      );

    default:
      return null;
  }
};

export default SuggestionStatusBadge;
